export const selectTargetMenuModalTranslationJP = {
  SelectTargetMenuModal: {
    target_menu_bar_guidance: 'ご案内：（{{name}}）',
    target_menu_overlay_function: '任意オーバーレイ名：（{{name}}）',
    target_menu_daily_menu: '日替わり曜日指定：（{{name}}）',
    target_menu_quantity_order_limit: 'コース注文数制限：（{{name}}）',
    target_menu_shabu_sukiyaki: '({{name}}）',
    target_menu_display_control_condition: '表示条件メニュー',
    target_menu_display_control_timing: '表示タイミング制御メニュー',
    target_menu_service: 'サービス',

    head_title: '対象メニュー追加',
    search: '絞り込み',
    menu_classification: 'メニュー分類',
    name: '名称',
    menu_code: 'メニューコード',
    select_all: '全選択',
    unselect_all: '解除',
    reload: 'リロード',
    add: '追加',
    select: '選択',
    menu_name: 'メニュー名',

    warn_confirm_add_menu_overlay_function:
      '対象メニューを追加します。対象メニューの任意オーバーレイ設定が変更されます。よろしいですか？',
    warn_confirm_add_menu_quantity_order_limit:
      '対象メニューを追加します。対象メニューの注文数制限設定が変更されます。よろしいですか？',
    warn_confirm_add_menu_display_control_timing:
      '対象メニューを追加します。対象メニューの表示タイミング設定が変更されます。よろしいですか？',
    warn_confirm_add_menu_service:
      '対象メニューを追加します。対象メニューのサービスプロパティがONになります。よろしいですか？',
  },
};
